'use strict';

(() => {
  if (window.OluvieInputModality) return;
  window.OluvieInputModality = true;
  const root = document.documentElement;
  root.dataset.orFocusInput = 'pointer';
  document.addEventListener('pointerdown', () => { root.dataset.orFocusInput = 'pointer'; }, { capture: true, passive: true });
  document.addEventListener('keydown', event => {
    if (!['Alt', 'Control', 'Meta', 'Shift'].includes(event.key)) root.dataset.orFocusInput = 'keyboard';
  }, { capture: true });
})();
